<script setup>
import { Form } from '@inertiajs/vue3'
import InputLabel from '@/components/InputLabel.vue'
import InputError from '@/components/InputError.vue'
import TextInput from '@/components/TextInput.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'
import InquiryDemandController from '@/actions/App/Http/Controllers/InquiryDemandController'
import { privacy } from '@/actions/App/Http/Controllers/LawController'

defineProps({
    services: {
        type: Array,
        required: true,
    },
})
</script>

<template>
    <div class="mx-auto w-full max-w-3xl">
        <div class="rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
            <div class="mb-8 text-center">
                <h3 class="text-2xl font-bold text-gray-900">Poptávkový formulář</h3>
                <p class="mt-2 text-gray-500">Vyplňte formulář a my se vám ozveme co nejdříve.</p>
            </div>

            <Form
                :action="InquiryDemandController.url()"
                resetOnSuccess
                method="post"
                #default="{ errors, processing, recentlySuccessful }"
                :options="{
                    preserveScroll: true,
                    preserveState: true,
                }"
            >
                <div class="space-y-6">
                    <div>
                        <InputLabel
                            for="name"
                            value="Jméno a příjmení"
                            is-required
                        />
                        <TextInput
                            id="name"
                            name="name"
                            type="text"
                            icon="user"
                            placeholder="Jan Novák"
                            autocomplete="name"
                            :class="{ 'border-red-500!': errors.name }"
                        />
                        <InputError
                            class="mt-1"
                            :message="errors.name"
                        />
                    </div>

                    <div>
                        <InputLabel
                            for="email"
                            value="E-mail"
                            is-required
                        />
                        <TextInput
                            id="email"
                            name="email"
                            type="email"
                            icon="email"
                            placeholder="jan.novak@email.cz"
                            autocomplete="email"
                            :class="{ 'border-red-500!': errors.email }"
                        />
                        <InputError
                            class="mt-1"
                            :message="errors.email"
                        />
                    </div>

                    <div>
                        <InputLabel
                            for="phone"
                            value="Telefon"
                        />
                        <TextInput
                            id="phone"
                            name="phone"
                            type="tel"
                            icon="phone"
                            placeholder="+420 123 456 789"
                            autocomplete="tel"
                            :class="{ 'border-red-500!': errors.phone }"
                        />
                        <InputError
                            class="mt-1"
                            :message="errors.phone"
                        />
                    </div>

                    <div>
                        <InputLabel
                            for="subject"
                            value="Služba"
                        />

                        <select
                            id="service_id"
                            name="service_id"
                            class="focus:border-brand-primary focus:ring-brand-primary block w-full rounded-lg border border-gray-300 px-4 py-3 text-base text-gray-900 focus:ring-1 focus:outline-none"
                            :class="{ 'border-red-500': errors.service_id }"
                        >
                            <option
                                v-for="service in services"
                                :key="service.id"
                                :value="service.id"
                            >
                                {{ service.name }}
                            </option>
                        </select>

                        <InputError
                            class="mt-1"
                            :message="errors.service_id"
                        />
                    </div>

                    <div>
                        <InputLabel
                            for="message"
                            value="Vaše zpráva"
                            is-required
                        />
                        <textarea
                            id="message"
                            name="message"
                            rows="5"
                            placeholder="Popište váš dotaz nebo požadavek..."
                            class="focus:border-brand-primary focus:ring-brand-primary block w-full rounded-lg border border-gray-300 px-4 py-3 text-base text-gray-900 placeholder:text-gray-400 focus:ring-1 focus:outline-none"
                            :class="{ 'border-red-500': errors.message }"
                        />

                        <InputError
                            class="mt-1"
                            :message="errors.message"
                        />
                    </div>

                    <div class="flex items-center gap-3">
                        <input
                            id="gdpr_consent"
                            name="gdpr_consent"
                            type="checkbox"
                            value="1"
                            class="text-brand-primary focus:ring-brand-primary size-4 rounded border-gray-300"
                            :class="{ 'border-red-500!': errors.gdpr_consent }"
                        />
                        <label
                            for="gdpr_consent"
                            class="text-sm text-gray-600"
                        >
                            Souhlasím se
                            <a
                                :href="privacy.url()"
                                aria-label="Odkaz na Zásady ochrany osobních údajů"
                                class="text-brand-primary hover:underline"
                                target="_blank"
                                >zpracováním osobních údajů</a
                            >
                            za účelem vyřízení mého dotazu.
                            <span class="text-red-500">*</span>
                        </label>
                    </div>
                    <InputError
                        class="mt-1"
                        :message="errors.gdpr_consent"
                    />

                    <div class="pt-4">
                        <PrimaryButton
                            type="submit"
                            :disabled="processing"
                            :success="recentlySuccessful"
                        >
                            {{ processing ? 'Odesílání...' : recentlySuccessful ? 'Odesláno' : 'Odeslat zprávu' }}
                        </PrimaryButton>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>
